import Icon from '@concur/nui-widgets/Icon';
import Text from '@concur/nui-widgets/Text';
import classnamesBind from 'classnames/bind';
import React from 'react';
import ScreenReaderMessageQueue from '../utils/ScreenReaderMessageQueue';
import styles from './SiteBanner.css';

const CSS_BLOCK = 'sapcnqr-site-banner';

const SiteBanner = React.forwardRef(({
    accentColor,
    iconName,
    sticky,
    stickyFrame,
    text,
    ...props
}, ref) => {
    const classnames = classnamesBind.bind(styles);
    return (
        <>
            {stickyFrame
            && (
                <div
                    id="sapCnqrTestEntitySiteBanner"
                    className={classnames(
                        `${CSS_BLOCK}__sticky-frame`,
                        `${CSS_BLOCK}__sticky-frame--accent-color-${accentColor}`,
                    )}
                />
            )}
            <div
                {...props}
                className={classnames(
                    CSS_BLOCK,
                    `${CSS_BLOCK}--accent-color-${accentColor}`,
                    {
                        [`${CSS_BLOCK}--sticky`]: sticky,
                    },
                )}
                ref={ref}
            >
                <Icon
                    ariaHidden
                    className={classnames(
                        `${CSS_BLOCK}__icon`,
                    )}
                    iconName={iconName}
                    size="sm"
                />
                <Text
                    className={classnames(
                        CSS_BLOCK,
                        `${CSS_BLOCK}__text`,
                        `${CSS_BLOCK}__text--accent-color-${accentColor}`,
                    )}
                    maxLines={1}
                >
                    {text}
                </Text>
                <ScreenReaderMessageQueue announcement={text} />
            </div>
        </>
    );
});

export default SiteBanner;
